<template>
  <content-layout :title="title" :headImage="headImage" :tabs="tabs" v-model="activeTab" :spin-show="spinShow">
    <div class="icons" slot="icons">
      <!-- <button style="button" class="layout-icon">
        <svg class="icon" aria-hidden="true">
          <use xlink:href="#icon-jiajianzujianjiahao"></use>
        </svg>
      </button> -->
    </div>
    <div slot="slogan"></div>
    <div class="activity-item mgui-container" slot="/check">
      <div class="filter-row">
          <Row>
            <Col :xs="24" :sm="16">
              <div class="filter-row-item">
                <Input v-model="filterItem.username" placeholder="筛选姓名" clearable style="width:120px" @on-enter="filterItemChange"></Input>
                <DatePicker type="daterange" confirm :options="timeOpt" v-model="filterItem.time" @on-clear="timeOnClear" @on-ok="timeOnChange" placement="bottom-start" placeholder="选择一个时间段" style="width:140px"></DatePicker>
                <!-- 类型： -->
                <RadioGroup v-model="filterItem.status" type="button" @on-change="filterItemChange">
                    <Radio :label="0">
                      注册审核<span class="badge" v-if="$store.state.badge.reg>0">{{$store.state.badge.reg}}</span>
                    </Radio>
                    <Radio :label="1">
                    入职审核<span class="badge" v-if="$store.state.badge.entry>0">{{$store.state.badge.entry}}</span>
                    </Radio>
                  <Radio :label="2">已审核</Radio>
                  <Radio :label="-1">全部</Radio>
                </RadioGroup>
              </div>
            </Col>
            <Col :xs="24" :sm="8" style="text-align:right">
              <!-- <span style="color:#999">&nbsp;&nbsp;|&nbsp;&nbsp;</span> -->
              <DatePicker
                  confirm
                  type="daterange"
                  :open="cwOpen"
                  v-model="exportTime"
                  placement="bottom-end"
                  :options="timeOpt"
                  @on-ok="fetchUserIds('cw')"
                  @on-clear="cwOpen = false"
                  >
                    <Button type="default" style="color:#2d8cf0;background:#fff" @click="cwOpen=!cwOpen" icon="logo-usd">导出财务表</Button>
              </DatePicker>
              <DatePicker
                  confirm
                  type="daterange"
                  :open="sbOpen"
                  v-model="exportTime"
                  placement="bottom-end"
                  :options="timeOpt"
                  @on-ok="fetchUserIds('sb')"
                  @on-clear="sbOpen = false"
                  >
                    <Button type="default" style="color:#2d8cf0;background:#fff" @click="sbOpen=!sbOpen" icon="md-heart">导出社保表</Button>
              </DatePicker>
            </Col>
          </Row>
        </div>
          <!-- </Col>
          <Col span="6">
            <Input v-model="filterItem.username" placeholder="筛选姓名"></Input>
          </Col>
          <Col span="6">
            <Cascader v-model="filterItem.department_id" placeholder="选择项目组" :data="$store.state.department" change-on-select></Cascader>
          </Col>
          <Col span="3"> -->
          <!-- </Col> -->
        <!-- </Row> -->
      <!-- <Table :columns="groupCol" :data="groupData"></Table> -->
      <div class="div-table">
        <Row class="div-table-head">
          <Col :xs="3" :sm="2">工号</Col>
          <Col :xs="9" :sm="10">
            <Row>
              <Col :xs="24" :sm="4">姓名</Col>
              <Col :xs="0" :sm="7">手机号</Col>
              <Col :xs="0" :sm="6">部门</Col>
              <Col :xs="0" :sm="6">项目组</Col>
            </Row>
          </Col>
          <Col :xs="5" :sm="3">入职时间</Col>
          <Col :xs="5" :sm="3"><span v-if="filterItem.status>0">审核时间</span>&nbsp;</Col>
          <Col :xs="5" :sm="3">状态</Col>
          <Col :xs="3" :sm="3">操作</Col>
        </Row>
        <div class="div-table-body">
          <loading :visible="spinShow" :text="spinText"></loading>
          <Row v-for="(item, ind) in groupData.data" :key="ind">
            <Col :xs="3" :sm="2">{{item.job_number}}</Col>
            <Col :xs="9" :sm="10">
              <Row>
                <Col :xs="24" :sm="4">
                  {{item.username}}
                  <Tooltip
                    class="col-tip"
                    content="部门主管" placement="right" v-if="item.role==1" style="color:#f00">
                    <Icon type="asterisk"></Icon>
                  </Tooltip>
                </Col>
                <Col :xs="24" :sm="7">
                  <template v-if="$menu.isPower('user', 'contact')">
                    {{item.mobile||'--'}}
                  </template>
                  <template v-else>
                    ***********
                  </template>
                </Col>
                <Col :xs="24" :sm="6">
                  {{formtDepartment(item.department_id)[0]}}&nbsp;
                </Col>
                <Col :xs="24" :sm="6">
                  {{formtDepartment(item.department_id)[1]}}&nbsp;
                </Col>
              </Row>
            </Col>
            <Col :xs="5" :sm="3">
              <span v-if="item.entry_time">
                {{item.entry_time}}
                <span v-if="isView(item)" @click="entryTimeFun(item)"><Icon type="md-create"></Icon></span>
              </span>
              <Button type="text" size="small" :disabled="!isView(item)" @click="entryTimeFun(item)" v-else>
                <u>未设置</u>
              </Button>
            </Col>
            <Col :xs="5" :sm="3">
              <span style="color:#999">{{item.check_time | formatTime}}</span>
            </Col>
            <Col :xs="5" :sm="3">
              <template v-if="item.entry_status<2 && filterItem.status>0">
                <Button size="small" v-if="isStatus(item) && item.check_time == null" @click="viewEntry(item)" :type="getType(item)">{{formatStatusText(item.entry_status)}}</Button>
                <Button size="small" v-else @click="viewEntry(item)" style="color:#f00" type="text">[已审]待修改</Button>
                <div style="color:#ccc">{{item.updated_at}}</div>
              </template>
              <template v-else-if="filterItem.status>0">
                {{$store.state.stateInfo[item.status].label}}
                <div style="color:#ccc">{{item.updated_at}}</div>
                <!-- <span @click="viewEntry(item)"><Icon type="document-text"></Icon></span> -->
              </template>
              <span v-else>
                {{$store.state.stateInfo[item.status].label}}
                <div style="color:#ccc">{{item.updated_at}}</div>
              </span>
            </Col>
            <Col :xs="3" :sm="3">
              <Button type="primary" @click="viewGroup(item)" size="small" icon="md-search" v-if="filterItem.status<=1">
                {{item.status==0?'查看审核':'个人资料'}}
              </Button>
              <Button type="success" @click="viewEntry(item)" icon="md-document" size="small" v-if="filterItem.status==2">入职资料</Button>
            </Col>
          </Row>
        </div>
      </div>
      <div class="pager">
        <Page :current="page.page" :page-size="groupData.per_page" :total="groupData.total" @on-change="pagerChange"></Page>
      </div>
      <Modal
          v-model="entryTimeModel"
          title="信息设置"
          width="400px"
          @on-ok="entryTimeOk"
          @on-cancel="entryTimeCancel">
            <div style="margin-bottom:15px">
              <label>合同到期时间：</label>
              <p style="padding:10px">
                <RadioGroup v-model="contractTimeLong" style="margin-bottom:10px">
                &nbsp;&nbsp;<Radio label="选择日期"></Radio>
                &nbsp;&nbsp;<Radio label="长期"></Radio>
                &nbsp;&nbsp;<Radio label="至项目结束"></Radio>
                </RadioGroup>
                <DatePicker format="yyyy年MM月dd日"  :editable="false" v-if="contractTimeLong == '选择日期'" v-model="contractTime" type="date" placeholder="选择合同到期时间" style="width:100%"></DatePicker>
              </p>
            </div>
            <div style="margin-bottom:15px">
              <label>入职时间：</label>
              <p style="padding:10px">
                <DatePicker format="yyyy年MM月dd日" :editable="false" v-model="entryTime" type="date" placeholder="选择入职时间" style="width:100%"></DatePicker>
              </p>
            </div>
            <div style="margin-bottom:15px">
              <label>是否有意外险：</label>
              <p style="padding:10px">
                <RadioGroup v-model="isSafe">
                  <Radio label="有"></Radio>
                  <Radio label="没有"></Radio>
                </RadioGroup>
              </p>
            </div>
            <!-- <Button style="vertical-align:top" type="info" @click="timeOk">确定</Button> -->
      </Modal>
    </div>
    <!-- <div class="activity-item mgui-container" slot="/users/post" style="padding-bottom:100px"> -->
    <!-- </div> -->
  </content-layout>
</template>

<script>
  import {formatTime} from '../util/filter'
  import {fetch, put, post} from '../fetch/api'
  let text = ['未提交', '入职审核', '入职资料']
  let color = ['text', 'warning', 'success']
  const formData = {
    'id': 0,
    'job_number': '0000',
    'role': 5,
    'mobile': null,
    'username': null,
    'nickname': '',
    'status': 0,
    'gander': 1,
    'group_id': 0,
    'updated_at': 0,
    'bio': ''
  }
  const modelName = 'user'
  export default {
    name: 'userEntry',
    components: {
      ContentLayout: resolve => { require(['../components/ContentLayoutComponent'], resolve) },
      Loading: resolve => { require(['../components/LoadingComponent'], resolve) },
      // UserEditForm: resolve => { require(['../components/UserEditFormComponent'], resolve) }
    },
    data () {
      return {
        title: '入职审核',
        tabs: [],
        activeTab: null,
        spinShow: false,
        exportTime: [],
        filterItem: {
          username: null,
          status: 1,
          department_id: [],
          time: []
        },
        isSub: false,
        usersCount: {},
        isSafe: '',
        groupData: {data: []},
        menusData: [],
        spinText: '正在加载...',
        entryTime: '',
        entryTimeModel: false,
        contractTime: '',
        contractTimeLong: '选择日期',
        userInfo: formData,
        currentItem: null,
        headImage: '/static/images/bg/money.jpeg',
        ruleData: {
          title: [
            {required: true, message: '请输入权限组名称', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入英文标识', trigger: 'blur'}
          ],
          node: [
            {required: true, message: '请选择管理项目', trigger: 'change'}
          ]
        },
        cwOpen: false,
        sbOpen: false,
        page: {
          page: 1
        },
        timeOpt: {
          shortcuts: [
            {
              text: '7天',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                return [start, end]
              }
            },
            {
              text: '30天',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                return [start, end]
              }
            },
            {
              text: '3个月',
              value () {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                return [start, end]
              }
            }
          ]
        }
      }
    },
    watch: {
      '$store.state.userInfo' () {
        this.setTabs()
      },
      $route (to) {
        this.routeChange(to)
      }
    },
    mounted () {
      // this.filterItem.time = this.init7Day()
      this.exportTime = this.init7Day()
      this.routeChange(this.$route)
      // this.fetchCount()
      this.setTabs()
    },
    filters: {
      formatTime (time) {
        if (!time) return '--'
        let date = new Date(time * 1000)
        return formatTime(date, 'yyyy-MM-dd hh:mm')
      }
    },
    methods: {
      init7Day () {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1)
        return [start, end]
      },
      fetchCount () {
        fetch('users/count').then(res => {
          this.usersCount = res
        })
      },
      routeChange (route) {
        if (route.query.status !== undefined && route.query.status !== '' && route.query.status !== null) {
          this.$set(this.filterItem, 'status', Number(route.query.status))
        }
        // if (route.query.page !== undefined && route.query.page !== '' && route.query.page !== null) {
        //   console.log(route.query.page)
        //   this.$set(this.page, 'page', route.query.page)
        // }
        if (route.query.department_id !== undefined && route.query.department_id !== '' && route.query.department_id !== null) {
          this.$set(this.filterItem, 'department_id', JSON.parse(route.query.department_id))
        }
        if (route.query.time !== undefined && route.query.time !== null && route.query.time !== '') {
          // console.log(route.query.time.split('|'))
          this.filterItem.time = route.query.time.split('|')
        }
        if (route.query.username !== undefined && route.query.username !== null && route.query.username !== '') {
          this.filterItem.username = route.query.username
        }

        let action = route.params.action
        if (action === undefined) {
          this.activeTab = '/check'
          // this.getDepartment()
          this.fetchData()
          // this.spinShow = false
        }
        if (action === 'reg') {
          this.activeTab = '/check/reg'
          // this.spinShow = false
        }
      },
      routeReplace () {
        let query = JSON.parse(JSON.stringify(this.filterItem))
        query.department_id = JSON.stringify(query.department_id)
        if (query.time[0]) query.time[0] = formatTime(this.filterItem.time[0], 'yyyy-MM-dd')
        if (query.time[1]) query.time[1] = formatTime(this.filterItem.time[1], 'yyyy-MM-dd')
        query.time = query.time.join('|')
        // query.page = this.page.page
        this.$router.push({path: '/check', query: query})
      },
      formatStatus (id) {
        let state = this.$store.state.stateInfo
        for (let k in state) {
          if (state[k].value === id) return state[k].label
        }
      },
      formatStatusText (status) {
        return text[status]
      },
      formtDepartment (id) {
        if (!id) return '--'
        // setTimeout(res => {
        let department = this.$store.state.department
        let ids = JSON.parse(id)
        let name = '--'
        for (let k in department) {
          if (department[k].children) {
            if (ids.length > 1) {
              for (let i in department[k].children) {
                if (department[k].children[i].__value === ids.join(',')) {
                  name = department[k].children[i].__label
                  break
                }
              }
            } else {
              if (department[k].value === ids[0]) {
                name = department[k].label
              }
            }
          }
        }
        name = name.split('/')
        return [name[0], name[1]]
        // }, 400)
      },
      setTabs () {
        this.isSub = this.$menu.isPower('user', 'sub')
        this.tabs = [
          {'title': '审核列表', 'key': '/check', 'visible': true}
        ]
      },
      getType (row) {
        return color[row.entry_status]
      },
      isView (row) {
        return row.id !== 1 && this.$menu.isPower(modelName, 'edit')
      },
      isDel (row) {
        return row.id !== 1 && this.$menu.isPower(modelName, 'del')
      },
      isStatus (row) {
        return row.id !== 1 && this.$menu.isPower(modelName, 'entry')
      },
      getDepartment () {
        this.$store.dispatch('setDepartment')
      },
      filterUsers () {
        this.fetchData()
        this.routeReplace()
      },
      timeOnChange () {
        this.fetchData()
        this.routeReplace()
      },
      timeOnClear () {
        this.filterItem.time = []
        this.routeReplace()
      },
      fetchData () {
        if (!this.spinShow) {
          this.groupData = {data: []}
          this.spinText = '正在加载...'
          // this.$set(this.page, 'total', 0)
          let params = JSON.parse(JSON.stringify(this.filterItem))
          params.page = this.page.page
          if (params.department_id !== null) params.department_id = JSON.stringify(params.department_id)
          this.$store.state.loadingState = true
          this.spinShow = true
          fetch(`users/checks`, {params: params}).then(res => {
            this.groupData = res
            // this.$set(this.page, 'total', res.total - 1)
            this.spinShow = false
            this.$store.state.loadingState = false
          }).catch(() => {
            this.spinText = '加载失败，请重试！'
            this.spinShow = false
          })
        }
      },
      fetchUserIds (type) {
        this.cwOpen = false
        this.sbOpen = false
        let params = {
          time: this.exportTime,
          export: 'export'
        }

        fetch(`users/export`, {params: params}).then(res => {
          if (res.status === 'ok') {
            window.location.href = this.apiPath + `export?cry=${res.cry}&type=${type}`
          } else {
            this.$Message.error(res.msg)
          }
        })
      },
      pagerChange (page) {
        this.page.page = page
        this.fetchData()
        this.routeReplace()
      },
      fetcMenus () {
        fetch('console/menus/0').then(res => {
          this.menusData = res
        })
      },
      handleMenusData () {
        if (this.formItem.node === '') return this.menusData
        let tmpData = JSON.parse(JSON.stringify(this.menusData))
        for (let i in tmpData) {
          let t = tmpData[i]
          let c = t.children
          if (this.inArr(tmpData[i].id)) tmpData[i].checked = true
          if (c.length > 0) {
            for (let k in c) {
              if (this.inArr(c[k].id)) c[k].checked = true
            }
          }
        }
        return tmpData
      },
      inArr (val) {
        let nodes = this.formItem.node.split(',')
        for (let i in nodes) {
          if (Number(nodes[i]) === Number(val)) return true
        }
        return false
      },
      treeChange (data) {
        let ids = []
        for (let k in data) {
          ids.push(data[k].id)
        }
        this.formItem.node = ids.join(',')
      },
      viewGroup (row) {
        this.$router.push({'path': `/user/view/${row.id}`})
      },
      viewEntry (row) {
        this.$router.push({'path': `/user/entry/${row.id}`})
      },
      editGroup (row) {
        this.formItem = {
          'id': row.id,
          'title': row.title,
          'name': row.name,
          'node': row.node
        }
        this.activeTab = 'form'
      },
      submitGroup (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            let data = this.formItem
            post(`/console/group`, data)
            .then(res => {
              if (res.status === 'ok') {
                this.$Message.success(data.id === 0 ? '添加成功' : '编辑成功')
                this.formItem = JSON.parse(JSON.stringify(formData))
                if (data.id > 0) {
                  this.activeTab = 'lists'
                }
                this.fetchData()
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 5
                })
              }
            })
            .catch(res => {
              this.$Message.error(res.msg)
            })
          } else {
            this.$Message.error('请确认表单是否填写完整')
          }
        })
      },
      clearForm () {
        this.activeTab = 'lists'
        this.formItem = JSON.parse(JSON.stringify(formData))
      },
      delOk (uid) {
        put(`/users/${uid}`).then(res => {
          if (res.status === 'ok') {
            this.fetchData()
          }
        })
      },
      entryTimeFun (item) {
        this.entryTimeModel = true
        this.currentItem = item
        if (item.entry_time) this.entryTime = item.entry_time
      },
      entryTimeOk () {
        if (typeof this.entryTime === 'object' && this.entryTime !== '') {
          let date = formatTime(this.entryTime, 'yyyy年MM月dd日')
          
          let contractTime
          // let d = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
          // date = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + d + '日'
          if (this.contractTimeLong === '选择日期') {
            contractTime = formatTime(this.contractTime, 'yyyy年MM月dd日')
          } else {
            contractTime = this.contractTimeLong
          }

          let data = {
            'entry_time': date,
            'contract_time': contractTime,
            'is_safe': this.isSafe === '有' ? 1 : 0
          }
          put(`users/info/${this.currentItem.id}`, data).then(() => {
            this.currentItem.entry_time = date
            this.$Message.info('修改成功')
            this.fetchData()
          }).catch(() => {
            this.$Message.info('修改失败请重试！')
          })
        }
        this.entryTime = ''
      },
      entryTimeCancel () {
        this.entryTime = ''
      },
      filterItemChange () {
        this.page.page = 1
        this.fetchData()
        this.routeReplace()
        // this.timeType = val
      }
    }
  }
</script>

<style>
  .users-count{
    position: absolute;
    right: 10px;
    bottom: 10px;
    z-index: 2;
    border: 1px solid #eee;
    border-radius: 4px;
    /*background: #f7f7f7;*/
    color: #fff;
    padding: 5px 10px;
  }
  .filter-row-item{display: inline-block;}
  .users-count span,.users-count a{
    margin-right: 10px
  }
  .users-count a{color:#fff;text-decoration: underline}
  @media (max-width: 640px) {
    .filter-row-item{display: block;margin-bottom: 10px}
    .users-count{width:200px;}
  }
</style>
